export default  {
    statusProposta: {
        COTACAO: 1,
        PROPOSTA: 2,
        EMITIDA: 3,
        APROVADA: 4,
        REPROVADA:5,
        RECUSADA:6,
        CANCELADA: 7,
        PENDENTE: 8,
        EM_PROCESSAMENTO: 9,
        EXPIRADA: 10,
        APOLICE_VENCIDA: 12,
    }
}



// WEBPACK FOOTER //
// ./src/helpers/tipo-proposta-cotacao.js